export default __webpack_public_path__ + "static/media/water-clock-dark.e195dbb8.svg";